var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"l-main p-organization"},[_c('TitleMain',{attrs:{"icon":"projects","isFaqHide":""}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.email)+"のお客様一覧")])]),_c('div',{staticClass:"l-container"},[_c('ListOrganization',{attrs:{"items":_vm.organizations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }